import React, {Component} from 'react';

export default class TeamMemberSelect extends Component {
    constructor(){
        super();
        this.displayName = this.displayName.bind(this);
    }

    displayName(){
        const {name, isActive} = this.props;

        if(!isActive){
            return(
                <div className='team-member-select-name'>
                    <h2>{name}</h2>
                </div>
            );
        } else {
            return null;
        }
    }

    render(){
        const {imgPath, isActive, selectMember} = this.props;
        const classname = isActive ? 'team-member-select member-is-active' : 'team-member-select';
        const style = {
            backgroundImage: `url(${imgPath})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
        }
        const name = this.displayName();

        return(
            <div
                className={classname}
                style={style}
                onClick={selectMember}>
                {name}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/meet_the_team/team_member_select.js